module.exports = __webpack_public_path__ + "img/Tessellate05.70b8e8c0.png";